const VocabDaysOfWeek = {
  sun_short: ['Dom', 'Sun'],
  mon_short: ['Lun', 'Mon'],
  tue_short: ['Mar', 'Tue'],
  wed_short: ['Mié', 'Wed'],
  thu_short: ['Jue', 'Thu'],
  fri_short: ['Vie', 'Fri'],
  sat_short: ['Sáb', 'Sat'],

  sun_full: ['Domingo', 'Sunday'],
  mon_full: ['Lunes', 'Monday'],
  tue_full: ['Martes', 'Tuesday'],
  wed_full: ['Miércoles', 'Wednesday'],
  thu_full: ['Jueves', 'Thursday'],
  fri_full: ['Viernes', 'Friday'],
  sat_full: ['Sábado', 'Saturday'],
};

export type VocabDaysOfWeekKey = keyof typeof VocabDaysOfWeek;
export default VocabDaysOfWeek;